// extracted by mini-css-extract-plugin
export default {"overlay":"ImageCrop_overlay__TdjA-","shadow":"ImageCrop_shadow__tODKK"};